import { occupationEcls } from '../../backend/constants';
import { licenseStatuses } from '../../backend/extraTypes';
import { useCredentialingTranslation } from './useCredentialingTranslation';
import { useFeatureFlags } from './useFeatureFlags';
export function useOccupationFilters() {
    const { t } = useCredentialingTranslation();
    const { credential: credentialingEnabled } = useFeatureFlags();
    const occupationFilters = (builder) => {
        builder.allFiltersPanel({
            key: '!occupation',
            label: t('filters.occupation.title'),
            children: getOccupationFilters(builder),
        });
    };
    const getOccupationFilters = (builder) => {
        const occupationFilterArray = [
            builder.allFiltersWidget({
                label: t('filters.occupation.occupationGroup'),
                type: 'form.select',
                key: 'occupationGroup',
                valueProvider: {
                    type: 'classifier.occupationGroup',
                },
            }),
            builder.allFiltersWidget({
                label: t('filters.occupation.occupation'),
                type: 'form.multiSelect',
                key: 'occupationIds',
                valueProvider: {
                    type: 'classifier.occupation',
                    paramsFromFormData: 'occupationGroup',
                },
            }),
            builder.allFiltersWidget({
                label: t('filters.occupation.credential'),
                type: 'form.multiSelect',
                key: 'credentialNames',
                valueProvider: {
                    type: 'classifier.occupationCredentialNames',
                },
            }),
            builder.allFiltersWidget({
                label: t('filters.occupation.status'),
                type: 'form.multiSelect',
                key: 'licenseStatuses',
                values: licenseStatuses.map((value) => ({
                    label: t(`licenseStatuses.${value}`),
                    value: value,
                })),
            }),
        ];
        if (credentialingEnabled) {
            occupationFilterArray.push(builder.allFiltersWidget({
                label: t('filters.occupation.ecl'),
                type: 'form.multiSelect',
                key: 'ecls',
                values: occupationEcls,
            }));
        }
        return occupationFilterArray;
    };
    return { occupationFilters, getOccupationFilters };
}
